import * as React from "react";

const LightbulbIcon = ({ width = "136", height = "169" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 136 169"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="lightbulb-icon">
      <path
        opacity="0.2"
        d="M3.53339 132.107L10.2871 120.478L55.1482 146.585L48.3733 158.198C47.9594 158.9 47.3487 159.47 46.621 159.832L33.0523 166.525C31.8097 167.139 30.3478 167.091 29.155 166.393L5.90456 152.864C4.71315 152.172 3.94723 150.925 3.86842 149.539L2.98432 134.436C2.93601 133.622 3.1294 132.815 3.53999 132.111L3.53339 132.107ZM17.0306 72.6523C14.4199 59.1546 16.4923 44.6864 23.9633 31.8451C39.6353 4.91355 74.8605 -6.69847 104.338 10.4565C132.358 26.7617 141.815 62.7818 125.449 90.908C117.98 103.746 106.421 112.698 93.3971 117.099C85.3276 119.824 71.1482 126.889 62.3021 134.994L50.2123 127.957C50.8405 127.067 51.5631 126.249 52.3695 125.514C57.0707 121.231 70.0839 110.469 89.0568 104.062C99.3894 100.568 108.106 93.4483 113.602 84.0065C126.123 62.4947 118.867 34.8351 97.4181 22.3503C76.6791 10.28 48.8367 16.2607 35.8308 38.7495C30.3639 48.2032 28.4226 59.209 30.511 69.9876C34.3355 89.7724 31.3648 106.421 29.9683 112.555C29.7319 113.596 29.3799 114.602 28.928 115.567L16.8383 108.53C19.5135 96.8314 18.6501 81.0153 17.0377 72.6476L17.0306 72.6523ZM47.5514 45.5735C56.2999 30.5424 75.5933 25.4146 90.5669 34.1255C92.5344 35.2702 93.2011 37.8001 92.0469 39.784C90.8927 41.768 88.3628 42.4347 86.3954 41.29C75.3553 34.8633 61.1305 38.6497 54.6848 49.7227C53.5305 51.7067 51.0007 52.3734 49.0332 51.2287C47.0658 50.084 46.399 47.5541 47.5533 45.5702L47.5514 45.5735Z"
        stroke="#696969"
        strokeWidth="4"
      />
    </svg>
  );
};

export default LightbulbIcon;
